import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import FormLabel from "@material-ui/core/FormLabel";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Box from "@material-ui/core/Box";
import { Chip } from "@material-ui/core";
import { DatabaseDateRangePicker } from "../../views/DatabaseLogs/DatabaseLogsTimeRange";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import "./customCalender.scss";
import LevelComponent from "../../shared/levelComponent";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import clsx from "clsx";
import { renderSensitivityValue } from "../../common/utilities";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "390px",
    overflowY: "scroll",
    borderLeft: "2px solid grey",
    padding: "10px",
  },
  level: {
    borderTop: "solid 2px #979797",
    marginTop: "15px",
    width: "84%",
  },
  resolve: {
    borderBottom: "solid 2px #979797",
    borderTop: "solid 2px #979797",
    marginTop: "15px",
    width: "90%",
  },
  ul: {
    listStyleType: "none",
  },
  li: {
    paddingBottom: "8px",
  },
  label: {
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.14",
    letterSpacing: "normal",
    color: "black",
  },
  FilterHead: {
    fontSize: "12px",
    lineHeight: 1.22,
    color: "black",
  },
}));
const useStyles_filter = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  formControlContainerSort: {
    width: "290px",
    background: "#DFE1E9",
    margin: "5px",
    borderRadius: "3px",
    paddingTop: "12px",
    paddingLeft: "10px",
  },
  formControlContainerFilter: {
    width: "250px",
    margin: "5px",
    borderRadius: "3px",
    paddingTop: "12px",
    paddingLeft: "10px",
    borderLeft: "2px solid grey",
    borderRight: "2px solid grey",
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#2947FD",
    border: "1px solid white",
    // backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    // '&:before': {
    //   display: 'block',
    //   width: 15,
    //   height: 16,
    //   content: '""',
    // },
    "input:hover ~ &": {
      backgroundColor: "#2947FD",
    },
  },
  databaseUsers: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  margin: {
    marginTop: "1rem",
  },
});
const useStyles_checkbox = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    backgroundColor: "#137cbd",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  },
});

export default function ServiceLevelFilterComponent(props) {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = React.useState(false);
  const [accessStatementsData, setAccessStatementsData] = React.useState([
    { value: "Statement Present" },
  ]);
  const [serviceUsersData, serServiceUsersData] = React.useState([
    { value: "ServiceUser Present" },
  ]);
  const classes = useStyles();
  const classes_check = useStyles_checkbox();

  const dataSourceName = useSelector(
    (state) => state.serviceAccessLogsReducer.dataSourceName
  );
  const dataSourceType = useSelector(
    (state) => state.serviceAccessLogsReducer.dataSourceType
  );
  const databaseAccessRoles = useSelector(
    (state) => state.serviceAccessLogsReducer.databaseAccessRoles
  );
  const policyNames = useSelector(
    (state) => state.serviceAccessLogsReducer.policyNames
  );
  const sensitivityInfo = useSelector(
    (state) => state.serviceAccessLogsReducer.sensitivityInfo
  );
  const applications = useSelector(
    (state) => state.serviceAccessLogsReducer.applications
  );
  const dataSourceNameFilter = useSelector(
    (state) => state.serviceAccessLogsReducer.apiDataSourceName
  );
  const dataSourceTypeFilter = useSelector(
    (state) => state.serviceAccessLogsReducer.apiDataSourceType
  );
  const databaseAccessRolesFilter = useSelector(
    (state) => state.serviceAccessLogsReducer.apiDatabaseAccessRoles
  );
  const policyNamesFilter = useSelector(
    (state) => state.serviceAccessLogsReducer.apiPolicyNames
  );
  const applicationFilter = useSelector(
    (state) => state.serviceAccessLogsReducer.apiDataapplications
  );
  const accessStatementFilter = useSelector(
    (state) => state.serviceAccessLogsReducer.apiDataAccessStatement
  );
  const serviceUsersFilter = useSelector(
    (state) => state.serviceAccessLogsReducer.apiDataServiceUsers
  );
  const sensitivityInfoFilter = useSelector(
    (state) => state.serviceAccessLogsReducer.apiSensitivityInfo
  );
  const fromTimeRange = useSelector(
    (state) => state.serviceAccessLogsReducer.fromTimeValue
  );
  const toTimeRange = useSelector(
    (state) => state.serviceAccessLogsReducer.toTimeValue
  );
  const alertId = useSelector(
    (state) => state.serviceAccessLogsReducer.alertId
  );

  const DatabaseLogsClickHandler = (event, name) => {
    switch (name) {
      case "dataSourceName": {
        dispatch({
          type: "SET_DATA_SOURCE_NAME_SERVICE_ACCESS_LOGS",
          payload: event.target.value,
        });
        dispatch({
          type: "MAINTAIN_SINGLE_DATA_SERVICE_ACCESS_LOGS",
          payload: {
            name: event.target.name,
            value: event.target.value,
            dispatchName: "SET_DATA_SOURCE_NAME_SERVICE_ACCESS_LOGS",
          },
        });
        break;
      }
      case "dataSourceType": {
        dispatch({
          type: "SET_DATA_SOURCE_TYPE_SERVICE_ACCESS_LOGS",
          payload: event.target.value,
        });
        dispatch({
          type: "MAINTAIN_SINGLE_DATA_SERVICE_ACCESS_LOGS",
          payload: {
            name: event.target.name,
            value: event.target.value,
            dispatchName: "SET_DATA_SOURCE_TYPE_SERVICE_ACCESS_LOGS",
          },
        });
        break;
      }
      case "databaseAccessRoles": {
        dispatch({
          type: "SET_DATABASE_ACCESS_ROLES_SERVICE_ACCESS_LOGS",
          payload: event.target.value,
        });
        dispatch({
          type: "MAINTAIN_SINGLE_DATA_SERVICE_ACCESS_LOGS",
          payload: {
            name: event.target.name,
            value: event.target.value,
            dispatchName: "SET_DATABASE_ACCESS_ROLES_SERVICE_ACCESS_LOGS",
          },
        });
        break;
      }
      // case "policyNames": {
      //   dispatch({ type: "SET_POLICY_NAMES", payload: event.target.value });
      //   dispatch({
      //     type: "MAINTAIN_SINGLE_DATA_SERVICE_ACCESS_LOGS",
      //     payload: {
      //       name: event.target.name,
      //       value: event.target.value,
      //       dispatchName: "SET_POLICY_NAMES",
      //     },
      //   });
      //   break;
      // }
      case "sensitivityInfo": {
        dispatch({
          type: "SET_SENSITIVITY_INFO_SERVICE_ACCESS_LOGS",
          payload: event.target.value,
        });
        dispatch({
          type: "MAINTAIN_SINGLE_DATA_SERVICE_ACCESS_LOGS",
          payload: {
            name: event.target.name,
            value: event.target.value,
            dispatchName: "SET_SENSITIVITY_INFO_SERVICE_ACCESS_LOGS",
          },
        });
        break;
      }
      case "application": {
        dispatch({
          type: "SET_APPLICATION_DATA_SERVICE_ACCESS_LOGS",
          payload: event.target.value,
        });
        dispatch({
          type: "MAINTAIN_SINGLE_DATA_SERVICE_ACCESS_LOGS",
          payload: {
            name: event.target.name,
            value: event.target.value,
            dispatchName: "SET_APPLICATION_DATA_SERVICE_ACCESS_LOGS",
          },
        });
        break;
      }
      case "accessStatement": {
        dispatch({
          type: "SET_ACCESS_STATEMENT_SERVICE_ACCESS_LOGS",
          payload: event.target.value,
        });
        dispatch({
          type: "MAINTAIN_SINGLE_DATA_SERVICE_ACCESS_LOGS",
          payload: {
            name: event.target.name,
            value: event.target.value,
            dispatchName: "SET_ACCESS_STATEMENT_SERVICE_ACCESS_LOGS",
          },
        });
        break;
      }
      case "serviceUser": {
        dispatch({
          type: "SET_SERVICE_USER_SERVICE_ACCESS_LOGS",
          payload: event.target.value,
        });
        dispatch({
          type: "MAINTAIN_SINGLE_DATA_SERVICE_ACCESS_LOGS",
          payload: {
            name: event.target.name,
            value: event.target.value,
            dispatchName: "SET_SERVICE_USER_SERVICE_ACCESS_LOGS",
          },
        });
        break;
      }
      default:
        return "";
    }
  };

  function StyledRadio(props) {
    const classes = useStyles_filter();
    return (
      <Radio
        className={classes.root}
        color="default"
        checked={accessStatementFilter.includes(props.value)}
        checkedIcon={
          <span className={clsx(classes.icon, classes.checkedIcon)} />
        }
        icon={<span className={classes.icon} />}
        {...props}
      />
    );
  }
  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className="filter">
      <FormLabel style={{ fontSize: "12px", paddingLeft: "10px" }}>
        {"Filter By"}
      </FormLabel>

      <div
        style={{
          width: "390px",
          minheight: "250px",
          overflow: "auto",
          wordBreak: "break-all",
        }}
      >
        <Accordion
          style={{ boxShadow: "none" }}
          expanded={expanded === "application"}
          onChange={handleChange("application")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header">
            <Typography className={classes.heading}>
              Application Name
            </Typography>
            <Typography className={classes.heading}>
              {applicationFilter.length || ""}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div
              style={{
                minheight: "350px",
                minWidth: "225px",
                display: "flex",
                flexDirection: "column",
                // marginTop: "2rem",
                paddingLeft: "1rem",
                overflow: "auto",
                height: "240px",
              }}
            >
              <FormGroup aria-label="position" row>
                <>
                  {applications &&
                    applications.map((each, index) => {
                      return (
                        <FormControlLabel
                          value={each.id}
                          name={each.name}
                          id={index}
                          control={
                            <Checkbox
                              className={classes_check.root}
                              checked={applicationFilter.includes(each.id)}
                              onChange={(event) =>
                                DatabaseLogsClickHandler(event, "application")
                              }
                              color="default"
                              checkedIcon={
                                <span className="checkbox-icon checked-icon" />
                              }
                              icon={<span className="checkbox-icon" />}
                              inputProps={{
                                "aria-label": "decorative checkbox",
                              }}
                            />
                          }
                          label={<p className={classes.label}>{each.name}</p>}
                          labelPlacement="end"
                        />
                      );
                    })}
                </>
              </FormGroup>
            </div>
          </AccordionDetails>
        </Accordion>
        {/* <Accordion
          style={{ boxShadow: "none" }}
          expanded={expanded === ""}
          onChange={handleChange("")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header">
            <Typography className={classes.heading}>
             Data Source UserName
            </Typography>
            <Typography className={classes.heading}>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div
              style={{
                minheight: "350px",
                minWidth: "225px",
                display: "flex",
                flexDirection: "column",
              
                paddingLeft: "1rem",
                overflow: "auto",
                height: "240px",
              }}
            >
              <FormGroup aria-label="position" row>
                <>
                  {dataSourceName &&
                    dataSourceName.map((each, index) => {
                      return (
                        <FormControlLabel
                          value={each.id}
                          name={each.aliasName}
                          id={index}
                          control={
                            <Checkbox
                              className={classes_check.root}
                              checked={dataSourceNameFilter.includes(each.id)}
                              onChange={(event) =>
                                DatabaseLogsClickHandler(
                                  event,
                                  "dataSourceName"
                                )
                              }
                              color="default"
                              checkedIcon={
                                <span className="checkbox-icon checked-icon" />
                              }
                              icon={<span className="checkbox-icon" />}
                              inputProps={{
                                "aria-label": "decorative checkbox",
                              }}
                            />
                          }
                          label={
                            <p className={classes.label}>{each.aliasName}</p>
                          }
                          labelPlacement="end"
                        />
                      );
                    })}
                </>
              </FormGroup>
            </div>
          </AccordionDetails>
        </Accordion> */}
        <Accordion
          style={{ boxShadow: "none" }}
          expanded={expanded === "dataSource"}
          onChange={handleChange("dataSource")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header">
            <Typography className={classes.heading}>
              Data Source Names
            </Typography>
            <Typography className={classes.heading}>
              {dataSourceNameFilter.length || ""}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div
              style={{
                minheight: "350px",
                minWidth: "225px",
                display: "flex",
                flexDirection: "column",
                // marginTop: "2rem",
                paddingLeft: "1rem",
                overflow: "auto",
                height: "240px",
              }}
            >
              <FormGroup aria-label="position" row>
                <>
                  {dataSourceName &&
                    dataSourceName.map((each, index) => {
                      return (
                        <FormControlLabel
                          value={each.id}
                          name={each.aliasName}
                          id={index}
                          control={
                            <Checkbox
                              className={classes_check.root}
                              checked={dataSourceNameFilter.includes(each.id)}
                              onChange={(event) =>
                                DatabaseLogsClickHandler(
                                  event,
                                  "dataSourceName"
                                )
                              }
                              color="default"
                              checkedIcon={
                                <span className="checkbox-icon checked-icon" />
                              }
                              icon={<span className="checkbox-icon" />}
                              inputProps={{
                                "aria-label": "decorative checkbox",
                              }}
                            />
                          }
                          label={
                            <p className={classes.label}>{each.aliasName}</p>
                          }
                          labelPlacement="end"
                        />
                      );
                    })}
                </>
              </FormGroup>
            </div>
          </AccordionDetails>
        </Accordion>
        {/* <Accordion
          style={{ boxShadow: "none" }}
          expanded={expanded === "dataSourceType"}
          onChange={handleChange("dataSourceType")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header">
            <Typography className={classes.heading}>
              Data Source Type
            </Typography>
            <Typography className={classes.heading}>
              {dataSourceTypeFilter.length || ""}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <div
              style={{
                minheight: "350px",
                display: "flex",
                flexDirection: "column",
                // marginTop: "2rem",
                paddingLeft: "1.5rem",
                overflow: "auto",
                height: "100px",
              }}
            >
              <FormGroup aria-label="position" row>
                <>
                  {dataSourceType &&
                    dataSourceType.map((each, index) => {
                      return (
                        <FormControlLabel
                          value={each.code}
                          name={each.code}
                          id={index}
                          control={
                            <Checkbox
                              className={classes_check.root}
                              checked={dataSourceTypeFilter.includes(each.code)}
                              onChange={(event) =>
                                DatabaseLogsClickHandler(
                                  event,
                                  "dataSourceType"
                                )
                              }
                              color="default"
                              checkedIcon={
                                <span className="checkbox-icon checked-icon" />
                              }
                              icon={<span className="checkbox-icon" />}
                              inputProps={{
                                "aria-label": "decorative checkbox",
                              }}
                            />
                          }
                          label={<p className={classes.label}>{each.code}</p>}
                          labelPlacement="end"
                        />
                      );
                    })}
                </>
              </FormGroup>
            </div>
          </AccordionDetails>
        </Accordion> */}

        <Accordion
          style={{ boxShadow: "none" }}
          expanded={expanded === "sensitivityInfo"}
          onChange={handleChange("sensitivityInfo")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header">
            <Typography className={classes.heading}>
              Sensitivity Level
            </Typography>
            <Typography className={classes.heading}>
              {sensitivityInfoFilter.length || ""}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <FormGroup aria-label="position" row>
              <>
                {sensitivityInfo &&
                  sensitivityInfo.map((each, index) => {
                    return (
                      <FormControlLabel
                        value={each.code}
                        name={each.code}
                        id={index}
                        control={
                          <Checkbox
                            className={classes_check.root}
                            checked={sensitivityInfoFilter.includes(each.code)}
                            onChange={(event) =>
                              DatabaseLogsClickHandler(event, "sensitivityInfo")
                            }
                            color="default"
                            checkedIcon={
                              <span className="checkbox-icon checked-icon" />
                            }
                            icon={<span className="checkbox-icon" />}
                            inputProps={{ "aria-label": "decorative checkbox" }}
                          />
                        }
                        label={
                          <LevelComponent level={renderSensitivityValue(each.code)}></LevelComponent>
                        }
                        labelPlacement="end"
                      />
                    );
                  })}
              </>
            </FormGroup>
          </AccordionDetails>
        </Accordion>

        <Accordion
          style={{ boxShadow: "none" }}
          expanded={expanded === "accessStatement"}
          onChange={handleChange("accessStatement")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header">
            <Typography className={classes.heading}>
              Access Statement
            </Typography>
            <Typography className={classes.heading}>
              {/* {sensitivityInfoFilter.length || ""} */}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <FormGroup aria-label="position" row>
              <>
                {accessStatementsData &&
                  accessStatementsData.map((each, index) => {
                    return (
                      //   <RadioGroup
                      //   defaultValue="severity"
                      //   aria-label="sortBy"
                      //   name="customized-radios"
                      //   // onChange={(event) => selectedDatabaseFilter(event)}
                      //     // onChange={(event) => dispatch()}

                      // >

                      //   <FormControlLabel
                      //     value={each.value}
                      //     control={<StyledRadio  /> }
                      //     label={each.value}

                      //   />

                      // </RadioGroup>

                      <FormControlLabel
                        value={each.value}
                        name={each.value}
                        id={index}
                        control={
                          <Checkbox
                            className={classes_check.root}
                            checked={accessStatementFilter.includes(each.value)}
                            onChange={(event) =>
                              DatabaseLogsClickHandler(event, "accessStatement")
                            }
                            color="default"
                            checkedIcon={
                              <span className="checkbox-icon checked-icon" />
                            }
                            icon={<span className="checkbox-icon" />}
                            inputProps={{ "aria-label": "decorative checkbox" }}
                          />
                        }
                        label={each.value}
                        labelPlacement="end"
                      />
                    );
                  })}
              </>
            </FormGroup>
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{ boxShadow: "none" }}
          expanded={expanded === "serviceUser"}
          onChange={handleChange("serviceUser")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header">
            <Typography className={classes.heading}>Service User</Typography>
            <Typography className={classes.heading}>
              {/* {sensitivityInfoFilter.length || ""} */}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <FormGroup aria-label="position" row>
              <>
                {serviceUsersData &&
                  serviceUsersData.map((each, index) => {
                    return (
                      <FormControlLabel
                        value={each.value}
                        name={each.value}
                        id={index}
                        control={
                          <Checkbox
                            className={classes_check.root}
                            checked={serviceUsersFilter.includes(each.value)}
                            onChange={(event) =>
                              DatabaseLogsClickHandler(event, "serviceUser")
                            }
                            color="default"
                            checkedIcon={
                              <span className="checkbox-icon checked-icon" />
                            }
                            icon={<span className="checkbox-icon" />}
                            inputProps={{ "aria-label": "decorative checkbox" }}
                          />
                        }
                        label={each.value}
                        labelPlacement="end"
                      />
                    );
                  })}
              </>
            </FormGroup>
          </AccordionDetails>
        </Accordion>
        {alertId !== "" && (
          <Accordion
            style={{ boxShadow: "none" }}
            expanded={expanded === "alertId"}
            onChange={handleChange("alertId")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              id="panel1a-header"
            >
              <Typography className={classes.heading}>Alert ID</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box p={1}>
                <Chip
                  label={alertId}
                  size="medium"
                  style={{ borderRadius: "3px" }}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        )}

        <Accordion
          style={{ boxShadow: "none" }}
          expanded={expanded === "timeRange"}
          onChange={handleChange("timeRange")}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />} id="panel1a-header">
            <Typography className={classes.heading}>Time Range</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {fromTimeRange && toTimeRange && (
              <DatabaseDateRangePicker
                loc="service-database-logs"
                timeStamps={props.timeStamps}
              />
            )}
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}
